import React from 'react';
import ReactDOM from 'react-dom/client';
import Outline from './Outline'
import OStore from './OStore'

import './Outline.css'
import './OStore.css'


const root = ReactDOM.createRoot(document.getElementById('root'));

let flex_dir = 'row'
let flex_ht = '100%'

// configure format and layout adjustments for small devices
let width = window.screen.availWidth
if(width < 700) {

    flex_dir = 'column'
    flex_ht = '50%'
    window.sessionStorage.setItem("device-type", "small");

}
else {
    window.sessionStorage.setItem("device-type", "normal");
}

root.render(
<div className='app-boundary' style={{display:'flex', flexDirection:flex_dir,height:flex_ht, background:'white'}}>
    <div style={{flexGrow: 0}}>
    <Outline/>
    </div>
    <div className='store-area' id='store_area' style={{flexGrow: 1}}>
        <OStore/>
    </div>
</div>
);
